import React from "react";
import UnProjetBlog from "/src/components/Common/UnProjetBlog";
export default {
  React,
  UnProjetBlog
};